// For full API documentation, including code examples, visit https://wix.to/94BuAAs

import wixWindow from 'wix-window';

$w.onReady(function () {
	//TODO: write your page related code here...
	if (wixWindow.formFactor === "Desktop" || wixWindow.formFactor === "Tablet") {
		// code that will only run on Desktop/Tablet
		$w("#html3").hide();
		$w("#html4").hide();
	} else if (wixWindow.formFactor === "Mobile") {
		$w("#html3").show();
	}
});